module.exports = __webpack_public_path__ + "img/netBg.fb1cbaa4.jpg";